import React, { useMemo } from 'react';
import { dollars, plural } from './shared';

/* What needs attention today: the live files over or near their stage limit, biggest first. */
export default function AttentionPanel({ live, cc, onOpenFile, onStage }) {
  const files = useMemo(() => (live?.files || []).filter((f) => f.status === 'red' || f.status === 'amber').slice(0, 8), [live]);
  const over = live?.pipeline_health?.over || 0;
  const near = live?.pipeline_health?.near || 0;
  const bookedWk = cc?.settlements?.week || {};
  return (
    <section className="gpj-panel" data-testid="gpc-attention">
      <div className="gpj-panel-h">
        <h2>Needs your attention today</h2>
        <p>{over || near ? `${over ? `${over} over limit` : ''}${over && near ? ' · ' : ''}${near ? `${near} near limit` : ''}` : 'Every live file is inside its stage limit'}</p>
      </div>
      {bookedWk.booked_count > 0 && (
        <div className="gpf-callout green" data-testid="gpc-attention-booked"><span><b>{plural(bookedWk.booked_count, 'settlement')}</b> worth <b>{dollars(bookedWk.booked)}</b> booked to settle this week — make sure docs and funds are in place.</span></div>
      )}
      {files.length === 0 ? (
        <div className="gpj-empty" data-testid="gpc-attention-empty">No files are over or near their stage limit.</div>
      ) : (
        <div className="gpc-att">
          {files.map((f) => (
            <button type="button" className={`gpc-ar ${f.status}`} key={f.id} onClick={() => onOpenFile?.({ id: f.id, deal_id: f.id })} data-testid={`gpc-att-${f.id}`}>
              <i />
              <div><b>{f.client}</b><small>{f.stage_label}{f.lender ? ` · ${f.lender}` : ''}{f.owner ? ` · ${f.owner}` : ''} · {f.next_action || 'Review file'}</small></div>
              <div className="r"><b>{dollars(f.amount)}</b><small>{f.bd_in_stage} business days{f.limit_days != null ? ` · limit ${Math.round(f.limit_days)}` : ''}</small></div>
            </button>
          ))}
        </div>
      )}
      {(live?.files || []).length > files.length && files.length > 0 && (
        <button type="button" className="gpj-btn sm" style={{ marginTop: 14 }} onClick={() => onStage?.('all')} data-testid="gpc-attention-all">See all {plural((live?.files || []).length, 'live file')} in Pipeline</button>
      )}
    </section>
  );
}
